/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import yoga_patient from "../../assets/images/other-pages/patient.jpg";
import AboutMRI2 from "../../assets/images/other-pages/florida_patients.jpg";
import shape from "../../assets/images/home-page/7-01-01.png";

import left_side from "../../assets/images/Service Page/womens Service/woments_big.jpg";
import { Link } from "react-router-dom";
import { useLenis } from "../SmoothScroll";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import abstruct from "../../assets/images/other-pages/abstruct_2.png";
import abstruct_1 from "../../assets/images/other-pages/abstract_4.png";
import DoneIcon from "@mui/icons-material/Done";
import Faqs from "../Faqs";
import { Helmet } from "react-helmet-async";
const PatientContent = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  const faqs = [
    {
      question:
        "How do I schedule an imaging appointment at Citrus Diagnostic Center?",
      answer:
        "Scheduling at Citrus Diagnostic Center is simple. Once your physician has provided an imaging order, you or your doctor's office can call us directly to book your appointment. Our staff will ask for your insurance information, the imaging order, and any relevant clinical history to ensure your visit goes smoothly.",
    },
    {
      question: "What should I bring to my imaging appointment?",
      answer:
        "Please bring a valid photo ID, your insurance card, your physician's imaging order (if not already sent to us), a list of current medications, and any prior relevant imaging studies or reports for comparison. For certain studies such as MRI, you may be asked to complete a safety screening form before your exam. Our staff will contact you prior to your appointment with any specific preparation instructions.",
    },
    {
      question: "How long will my imaging appointment take?",
      answer:
        "Appointment length varies by study. Most X-rays take under 15 minutes. Ultrasound studies typically take 30 minutes. A standard MRI typically takes 20 to 45 minutes depending on the body part and whether contrast is included. CT scans are generally 10 to 20 minutes. Nuclear medicine studies may require multiple visits or extended imaging sessions. Our scheduling team will give you an accurate time estimate when you book your appointment.",
    },
    {
      question: "When will I receive my imaging results?",
      answer:
        "At Citrus Diagnostic Center, your imaging study is interpreted by our board-certified radiologist and a written report is sent to your referring physician, typically within 48 to 72 hours for routine studies, with  STAT results within 2 hours. Your referring physician will then contact you to discuss the findings and any recommended next steps. We do not release reports directly to patients, but your doctor can share your results and images with you.",
    },
    {
      question: "Is imaging at Citrus Diagnostic Center safe?",
      answer:
        "Yes. Diagnostic imaging at Citrus Diagnostic Center is performed by trained, licensed technologists using state-of-the-art equipment operated under the supervision of our board-certified radiologists. MRI uses no ionizing radiation. For studies that use X-rays - such  as CT, DEXA, mammography, and conventional X-ray - radiation doses are carefully optimized using dose-reduction protocols to minimize exposure while preserving diagnostic image quality. Your safety and comfort are our top priorities.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Patient Portal – Imaging Reports Online at Citrus Diagnostics
        </title>
        <meta
          name="description"
          content="How can you access your reports? Use our patient portal to check medical records, imaging outcomes, and manage health information securely in one place."
        />
        <meta
          name="keywords"
          content="Patient Portal
diagnostic center
electronic health records
Patient Forms
Imaging Reports"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 text-[#ccc]">
        <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  px-4 text-center capitalize w-full">
          Patient Education & Imaging Safety
        </h1>
        <p className=" xl:mb-20 md:px-8 px-4 text-center">
          Knowledge that empowers. Imaging you can trust.
        </p>
        <div className="lg:w-[90%] w-[95%] mx-auto lg:pt-16 pt-8  leading-[34px]  ">
          <div className="grid xl:grid-cols-2 grid-cols-1 gap-10 justify-center items-center 2xl:px-24  rounded-xl">
            <div className="  2xl:p-14 xl:p-8 px-6 py-6 flex flex-col justify-center ">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize">
                Your Health. Your Choice. Your Imaging.
              </h2>
              <p className="mt-6">
                At Citrus Diagnostic Center, we believe informed patients make
                better decisions-and deserve transparency, safety, and respect
                at every step.
              </p>{" "}
              <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-2">
                <div className="w-full ">
                  <p className="pb-1.5">This education hub is designed to:</p>
                  <ul className=" flex flex-col gap-2 pt-2.5  text-left font-robout">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Explain imaging in clear, patient-friendly language
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Help you understand why an exam is ordered
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Address safety, radiation, and preparation questions
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Support your right to choose where imaging is performed
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="  flex justify-center items-center rounded-xl    2xl:p-14 xl:p-8 ">
              <div className="text-[20px] leading-[34px] lg:my-3 flex justify-center items-center ">
                <img
                  src={yoga_patient}
                  alt="happy patients at CDC"
                  className="rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="w-full bg-cover  bg-center xl:py-10 py-4"
          style={{
            background: `url(${abstruct_1}) , #2e0504`,
          }}
        >
          <div className="lg:w-[90%] w-[95%] mx-auto my-10  leading-[34px]  ">
            <div
              style={{
                background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
              }}
              className=" xl:mt-0 mt-14 pt-12  rounded-xl backdrop-blur-xl"
            >
              <div className="2xl:px-14 xl:px-8 px-6">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize text-center">
                  Understanding Medical Imaging
                </h2>
              </div>

              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-20 xl:pt-14 xl:ms-10  p-6">
                <div className=" pb-10 ">
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal  ">
                    What Is Medical Imaging?
                  </h3>
                  <div className=" lg:gap-10 gap-5 mt-6">
                    <div className="w-full ">
                      <p className="">
                        Medical imaging uses advanced technology to help
                        physicians:
                      </p>
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Detect disease
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Guide treatment
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Monitor response
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Support prevention and early diagnosis
                        </li>
                      </ul>
                      <p className="pt-6">Common imaging modalities include:</p>
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          MRI (Magnetic Resonance Imaging)
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          CT (Computed Tomography)
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          PET-CT (Positron Emission Tomography-CT)
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Ultrasound
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Digital X-ray
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Mammography
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Nuclear medicine
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          DEXA bone density scanning
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className=" rounded-xl  xl:bg-transparent flex flex-col  items-start 2xl:px-12 xl:px-8">
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal  ">
                    What Is Radiology?
                  </h3>
                  <p className="mt-5">
                    Radiology is a medical specialty that uses advanced
                    imaging-such as MRI, CT, PET, ultrasound, and mammography-to
                    diagnose disease, guide treatment, and monitor response to
                    therapy.
                  </p>
                  <h3 className="text-2xl pt-6  lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                    What Is a Radiologist?
                  </h3>

                  <div className=" lg:gap-10 gap-5 lg:mt-6">
                    <div className="w-full ">
                      <p className="">
                        A radiologist is a physician who completes:
                      </p>
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                          Medical school
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                          Residency in diagnostic radiology
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                          Fellowship training (often subspecialty-focused)
                        </li>
                      </ul>

                      <p className="pt-2">
                        Radiologists are medical imaging experts who interpret
                        studies, consult with referring physicians, and help
                        guide patient care-often behind the scenes, but critical
                        at every step.
                      </p>
                      <p className="pt-2">
                        At Citrus Diagnostic Center, radiologists are not
                        contractors-we are the owners and clinical leaders.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-[90%] w-[95%] mx-auto">
          <div className=" justify-center items-center xl:px-20 xl:py-14 py-7 px-6 xl:mb-0 mb-5 rounded-xl">
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-10 ">
              <div className="flex flex-col justify-center items-start xl:px-0">
                <h3 className=" pt-4 lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                  MRI Safety
                </h3>
                <p className="">Powerful imaging. No radiation.</p>{" "}
                <p className="mt-6 lg:w-2/3 w-full">
                  MRI uses strong magnetic fields and radio waves-not ionizing
                  radiation.
                </p>{" "}
                <div className=" lg:gap-10 gap-5 mt-2">
                  <div className="w-full ">
                    <p className="">What Patients Should Know:</p>
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        MRI is safe for most people
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Thorough safety screening is performed before every exam
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Certain implants or devices require special evaluation
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Wide-bore and open systems improve comfort
                      </li>
                    </ul>
                    <p className="mt-6">Our team ensures MRI exams are:</p>
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Carefully screened
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Appropriately selected
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Supervised by radiologists
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="  rounded-xl xl:pt-4 ">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal  mt-2 ">
                  CT & Radiation Safety
                </h3>
                <p className="">Right test. Right dose.</p>{" "}
                <div className=" lg:gap-10 gap-5 mt-6">
                  <div className="w-full ">
                    <p className="lg:w-2/3 w-full">
                      CT imaging uses X-rays to create detailed images. At
                      Citrus Diagnostic Center:
                    </p>
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Radiation dose is minimized
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        AI-based dose optimization is used when appropriate
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Exams follow national safety standards
                      </li>
                    </ul>
                    <p className="my-5  ">Image Wisely® Commitment</p>
                    <p>We support the Image Wisely® initiative to ensure:</p>
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        {" "}
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Radiation is used only when clinically appropriate
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        The lowest effective dose is applied
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Each exam provides meaningful diagnostic value
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" w-full flex justify-center items-center mt-2 overflow-hidden">
            <div className="flex justify-center items-center xl:pb-16 pb-14  w-full ">
              <img
                src={left_side}
                alt="mammography imaging"
                className="object-cover w-full rounded-xl"
              />{" "}
            </div>
          </div>
          <div
            style={{
              backgroundImage:
                "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
            }}
            className=" justify-center items-center 2xl:px-20 xl:pt-10 pb-10  rounded-xl"
          >
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-20 xl:ms-10">
              <div className=" lg:pb-8 pt-2 2xl:px-12 xl:px-8 px-6  pb-4 ">
                <div className=" lg:gap-10 gap-5 mt-6">
                  <h3 className=" lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                    PET-CT Safety & Preparation
                  </h3>
                  <p className="">Molecular imaging with purpose.</p>{" "}
                  <p className="mt-6 w-full">
                    PET-CT involves a small amount of radioactive tracer to
                    evaluate tissue function.
                  </p>{" "}
                  <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-2">
                    <div className="w-full ">
                      <p className="">Patients are guided through:</p>{" "}
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Exam preparation
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          What the tracer does
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          What to expect during the scan
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Post-exam safety considerations
                        </li>
                      </ul>
                      <p className="mt-6">All PET-CT exams are:</p>
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Physician-supervised
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Dose-optimized
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Aligned with evidence-based protocols
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="2xl:px-12 xl:px-8 px-6 flex flex-col items-start ">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal  pt-2 mt-6 ">
                  Ultrasound
                </h3>
                <p className="">Safe. Non-invasive. Radiation-free.</p>
                <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-6">
                  <div className="w-full ">
                    <p className="">
                      Ultrasound uses sound waves and is commonly used to
                      evaluate:
                    </p>{" "}
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Abdominal and pelvic organs
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Blood vessels
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Soft tissues
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Muscles and tendons
                      </li>
                    </ul>
                    <p className="mt-6  tracking-wider">Ultrasound:</p>
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Does not use radiation
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Is safe during pregnancy
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        Allows real-time imaging
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative md:max-w-[90%] w-11/12 mx-auto  overflow-hidden xl:bg-[#0f0f0f] rounded-xl lg:my-16 my-10 lg:py-16 py-10">
          {/* 🔥 Background Shape */}
          <img
            src={shape}
            alt="Citrus Diagnostic Center"
            className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-75
    "
          />

          <div
            className=" backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl
      shadow-lg xl:w-11/12  mx-auto py-8 xl:px-10 px-6"
          >
            <div>
              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24">
                <div className=" flex flex-col  px-5 xl:px-0 ">
                  <h3 className="   lg:mt-8 lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal ">
                    Mammography & Women’s Imaging
                  </h3>
                  <p className="">Focused on early detection.</p>{" "}
                  <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-6">
                    <div className="w-full ">
                      <p className="">
                        3D mammography (tomosynthesis) improves:
                      </p>{" "}
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Cancer detection
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Visualization of dense breast tissue
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Diagnostic confidence
                        </li>
                      </ul>
                      <p className="mt-6 ">
                        AI-assisted tools support radiologists, while:
                      </p>
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Every exam remains physician-interpreted
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Safety and comfort are prioritized
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          National screening guidelines are followed
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="  rounded-xl xl:p-8 px-5  py-5 xl:my-0 mt-5 ">
                  <h3 className=" lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                    Nuclear Medicine & Bone Health
                  </h3>
                  <p className=" mt-6 tracking-wider">Nuclear Medicine</p>

                  <div className=" grid grid-cols-1 lg:gap-10 gap-5 mt-5">
                    <div className="w-full ">
                      <p className="">Used to evaluate:</p>{" "}
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Bone metabolism
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Organ function
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Occult injuries
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Disease activity
                        </li>
                      </ul>
                      <p className="mt-6 tracking-wider">
                        DEXA Bone Density Scans
                      </p>
                      <p className="mt-5">
                        DEXA uses very low-dose X-rays to assess:
                      </p>
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Osteoporosis
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Fracture risk
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Bone health over time
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-[90%] w-[95%] mx-auto">
          <div className=" w-full flex justify-center items-center mb-14 xl:mb-16 xl:mt-0 mt-8 overflow-hidden">
            <div className="flex justify-center items-center  w-full ">
              <img
                src={AboutMRI2}
                alt="Citrus Diagnostic Cneter in Florida"
                className="object-cover w-full md:rounded-3xl"
              />
            </div>
          </div>
          <div
            style={{
              backgroundImage:
                "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
            }}
            className=" justify-center items-center 2xl:px-20 xl:py-12 pt-10 pb-10  rounded-xl"
          >
            <div className=" 2xl:px-14 xl:px-8 px-6 text-center">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize text-center">
                Your Right to Choose
              </h2>
              <p className="  ">Patient choice matters.</p>{" "}
            </div>
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-20 xl:pt-10  xl:ms-10">
              <div className=" 2xl:px-12 flex  items-start flex-col xl:px-8 px-6  pt-5">
                <p className="">Patients have the right to:</p>
                <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                    Ask questions
                  </li>
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                    Understand their imaging
                  </li>
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                    Choose where imaging is performed
                  </li>
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className=" text-[#bf9c5e]" />
                    Receive care without self-referral pressure
                  </li>
                </ul>
              </div>
              <div className=" px-6 lg:px-0 py-5 ">
                <div className=" grid grid-cols-1 lg:gap-10 gap-5">
                  <div className="w-full ">
                    <p>Citrus Diagnostic Center is:</p>
                    <div className="w-full xl:pe-20">
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          100% referral-based
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Radiologist-owned and operated
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Focused on patient-first decision-making
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center xl:px-20 p-6 xl:py-10  rounded-xl">
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-10 gap-5 ">
              <div className=" flex flex-col  items-start ">
                <h3 className=" mb-6 mt-6 lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                  Privacy, Security & Trust
                </h3>
                <div className=" ">
                  <div className="w-full ">
                    <p>Your health information is protected through:</p>
                    <div className="w-full ">
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          HIPAA-compliant systems
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Secure digital infrastructure
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Professional IT oversight
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-1 text-[#bf9c5e]" />
                          Responsible AI governance
                        </li>
                      </ul>
                    </div>
                    <p className="mt-2">
                      Your privacy is foundational-not optional.
                    </p>
                    <div className=" lg:gap-10 gap-5">
                      <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em]  lg:mt-10 mt-7 text-[#cccccc] font-normal ">
                        Faster, Safer Records Sharing
                      </h3>
                      <p className="">Modern access-without the obstacles.</p>
                      <p className="mt-6">
                        When you need to share your imaging with another
                        facility or provider, we support secure digital sharing
                        designed to reduce delays and eliminate unnecessary
                        steps.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="  rounded-xl xl:p-8  py-6">
                <h3 className=" lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                  Digital Experience
                </h3>
                <p className="  tracking-wider">
                  Your imaging. Clear access. Less friction.
                </p>
                <p className="mt-6">
                  At Citrus Diagnostic Center, your experience doesn’t end when
                  the exam is complete. We provide secure, convenient digital
                  tools so you can stay informed and connected-without
                  unnecessary delays.
                </p>
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal lg:mt-10 mt-7 ">
                  Patient Portal Access
                </h3>
                <p className=" ">Everything in one place.</p>
                <div className="mt-6">
                  <div className="w-full">
                    <p className="">
                      Through our secure patient portal, you can access key
                      information related to your imaging visit, including:
                    </p>
                    <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Appointment details and reminders
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Study prep overview (when applicable)
                      </li>
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-1 text-[#bf9c5e]" />
                        Results and communications made available to you{" "}
                      </li>
                    </ul>
                  </div>
                  <p className="mt-8 font-bold">
                    <Link
                      target="_blank"
                      to="https://citrusfl.abbadox.com/patientportal/login"
                      className="px-8 py-2.5 rounded-3xl bg-white text-black hover:bg-black hover:border hover:text-[#fff] border border-[#ffffff5d] transition-all duration-300"
                    >
                      Patient Login
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="flex justify-center items-center w-full xl:h-screen"
          style={{
            background: `url(${abstruct})`,
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
          }}
        >
          <div
            className="lg:w-[90%] w-[95%] mx-auto   leading-[34px] backdrop-blur-xl lg:p-16 p-8 rounded-xl"
            style={{
              background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
            }}
          >
            <div className=" justify-center items-center rounded-xl">
              <div className="grid xl:grid-cols-2 grid-cols-1  xl:gap-20 ">
                <div className="   ">
                  <div className="">
                    <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                      Preparing for Your Imaging Exam
                    </h3>
                    <p className="">
                      {" "}
                      Clear instructions. Personalized delivery. No confusion.
                    </p>
                    <p className="mt-6">
                      Preparation for imaging exams varies based on the type of
                      study, clinical indication, and patient-specific factors.
                    </p>
                    <p className="mt-2">
                      To ensure accuracy and safety, Citrus Diagnostic Center
                      provides personalized preparation instructions directly to
                      patients through our secure patient communication system.
                    </p>
                    <div className="w-full xl:pe-20">
                      <p className=" text-[#cccccc] font-normal mt-2">
                        What Patients Can Expect:
                      </p>
                      <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Exam-specific preparation instructions
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Automated reminders via text and/or email
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Secure access through the patient portal{" "}
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Clear guidance tailored to the exact study being
                          performed
                        </li>
                      </ul>
                    </div>
                    <p className="mt-2">
                      Please follow the instructions sent to you directly, as
                      they are customized for your exam and may differ from
                      general information found online.
                    </p>
                    <p className="mt-2">
                      If you have not received instructions or have questions,
                      our team is here to help.
                    </p>
                  </div>
                </div>
                <div className=" flex flex-col  items-start">
                  <div className="text-[20px] leading-[34px] xl:pt-0 pt-10 ">
                    <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal">
                      Trusted Educational Resources
                    </h3>
                    <div className=" grid  grid-cols-1 lg:gap-10 gap-5 mt-6">
                      <div className="w-full xl:pe-20">
                        <p className="">
                          We align patient education with nationally recognized
                          organizations, including:
                        </p>
                        <ul className="list-disc  flex flex-col gap-2  pt-2.5  text-left font-robout">
                          <li className="flex items-start gap-2">
                            <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                            RadiologyInfo.org
                          </li>
                          <li className="flex items-start gap-2">
                            <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                            American College of Radiology (ACR)
                          </li>
                          <li className="flex items-start gap-2">
                            <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                            Image Wisely®{" "}
                          </li>
                          <li className="flex items-start gap-2">
                            <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                            Image Gently®
                          </li>
                        </ul>
                      </div>
                    </div>
                    <p className="mt-2">
                      These resources provide reliable, evidence-based
                      information you can trust.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-[80%] w-[90%] mx-auto   leading-[34px] lg:pb-20 pb-10">
          <Faqs faqs={faqs} />
        </div>

        <div class Name="flex justify-center items-center py-8 mb-8 mt-2">
          <div
            style={{
              background: `
                        linear-gradient(90deg,
                      #3d0e26 0%,
                      #5a1f33 1%,
                      #8b5e3c 40%,
                      #8b5e3c 70%,
                      #5a1f33 95%,
                      #330a16 100%
                    )
                      `,
            }}
            className="flex justify-center items-center xl:w-[668px] flex-col mt-4 py-8 px-6 xl:px-8 rounded-xl"
          >
            <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
              Take the Next Step
            </h2>
            <p className=" pt-5 px-4 text-center">
              Whether you’re scheduling an exam or learning about your options,
              we’re here to help.
            </p>
            <div className=" pt-5 pb-5">
              <Link
                data-aos="fade-up"
                to="/contact"
                aria-label="Schedule Now"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Schedule Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientContent;
